import {
    RETRY_COUNT,
    STALE_TIME_RESOURCES,
} from "@impero-com/common/utils/query_client";

import {
    GetControlsQueryResult,
    useGetControls,
    useGetControlsSuspense,
} from "api/generated/controls/controls";
import { WebSchedulingType } from "api/generated/model";

const queryOptions = {
    staleTime: STALE_TIME_RESOURCES,
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    refetchOnReconnect: true,
    retry: RETRY_COUNT,
    select: (response: GetControlsQueryResult) => response.data,
};

export function useControlsQuery(schedulingType?: WebSchedulingType) {
    return useGetControls(
        { scheduling_type: schedulingType },
        { query: queryOptions }
    );
}

export function useControlsSuspenseQuery(schedulingType?: WebSchedulingType) {
    return useGetControlsSuspense(
        { scheduling_type: schedulingType },
        { query: queryOptions }
    );
}
